import { render, staticRenderFns } from "./TicketEditTabLog.vue?vue&type=template&id=48a04c98"
import script from "./TicketEditTabLog.vue?vue&type=script&lang=js"
export * from "./TicketEditTabLog.vue?vue&type=script&lang=js"
import style0 from "./TicketEditTabLog.vue?vue&type=style&index=0&id=48a04c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports